import { render, staticRenderFns } from "./SkillList.vue?vue&type=template&id=2edb0859"
import script from "./SkillList.vue?vue&type=script&lang=js"
export * from "./SkillList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports